<template>
    <div id="logout-button">
        <b-button class="inline-submenu-btn with_icon" @click="logout()">
            <b-icon icon="power" aria-hidden="true"></b-icon>
            Déconnexion
        </b-button>
    </div>

</template>

<script>
export default {
    methods: {
        logout() {
            this.$store.dispatch('authAdmin/logout');
        }
    }
}
</script>

<style lang="scss" scoped>
#logout-button {
    position: absolute;
    top: 5px;
    left: 5px;
}
</style>